// src/api/config.mjs

export const SERVICE_SPECIFICID = process.env.REACT_APP_SERVICE_SPECIFICID
export const BASE_URL = process.env.REACT_APP_BASE_URL
export const API_BASE_URLS = {
  ADMIN_SERVICE: process.env.REACT_APP_ADMIN_SERVICE,
  CLIENT_SERVICE: process.env.REACT_APP_CLIENT_SERVICE,
  NAPID_AUTH_SERVICE: process.env.REACT_APP_NAPID_AUTH_SERVICE,
};
  
